import React, { useContext } from 'react';

import RouterFactory from '../../routing/child-router-factory';

import { createConfig } from './route-config';

import { RouterContext } from '../../context/routing';

const MainRouter = () => {
  const routing = useContext(RouterContext);

  const map = routing?.routingMap;
  return (
    <RouterFactory
      config={createConfig(map)}
      defaultRedirect={map.app.selfService._}
    />
  );
};

export default MainRouter;
